import React, { Component } from 'react';
import { getCharacterList } from './CharacterList';
import { readPublicMetadata } from '../../../api/publicMetadata';
import './CharactersCanvasV2.css';

export default class CharactersCanvasV2 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            characterList: [],
            isLoading: false,
            error: null,
        };
    }

    componentDidMount() {
        this.setState({ isLoading: true });

        readPublicMetadata()
            .then((metadata) => this.setState({
                characterList: getCharacterList(metadata.characterSheetsBaseUrl),
                isLoading: false,
            }))
            .catch((error) => this.setState({ error, isLoading: false }));
    }

    render() {
        const { characterList, isLoading, error } = this.state;


        if (error) {
            return <p>{error.message}</p>;
        }

        if (isLoading) {
            return <p>Loading ...</p>;
        }

        return (
            <div className="characterCanvasContainer ContentPage">
                <div className="charactersList">
                    {characterList}
                </div>
            </div>
        );
    }
}
